<div [hidden]="!showDialog" class="dialog">
   <div class="msgbox-container move">
      <div class="msg-title move-control">
         <div><span>{{dialogMsg.title}}</span></div>
      </div>
      <div class="content">
         <span><pre>{{dialogMsg.msg}}</pre></span>
      </div>

      <div class="action">
         <button class="btn btn-outline-primary btn-sm " *ngFor="let btn of buttons[dialogMsg.buttonType]" (click)="onBtnClick(btn)">{{btn}}</button>
      </div>
   </div>
</div>
